import { Injectable } from '@angular/core';
import { BaseDataService } from 'app/core/services/base-data.service';
import { HotelPage } from '../models/hotel-page.model';
import { API_MAP } from 'app/core/helpers/api.map';
import { Result } from 'app/core/models/result';
import { Observable, tap } from 'rxjs';

@Injectable()
export class HotelPageService extends BaseDataService<HotelPage>{

  override controller = API_MAP.hotelPage;

  override get(controller?: string): Observable<Result<any>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }
}
